// pincode-checker.js
// Delivery date checker.
//
// Lookup priority for every check:
//   1) Cobay EDD API            (live, authoritative)
//   2) Merchant CSV             (settings.delivery_csv_url)
//   3) Theme asset CSV          (Bluedart and Delhivery updated Pincodes.csv)
//   4) ziplistpredt / ziplistcoddt globals shipped in pincode-list.js
//
// The CSV/asset data is only fetched when the API is unusable, so a healthy API
// costs one small request instead of a multi-MB CSV download.
(async function () {
  if (!$("#kshipit").length) return;

  // --- Read config injected from the pincode-checker snippet ---
  var CFG = window.DELIVERY_CONFIG || {};
  var COD_ENABLED = (typeof CFG.codEnabled === 'undefined') ? true : !!CFG.codEnabled;
  var CSV_URL = CFG.csvUrl || null;
  var ASSETS_FALLBACK = CFG.assetsFallbackUrl || '/assets/ziplist.csv';

  var API_URL = CFG.eddApiUrl || 'https://api.cobay.com/public/serviceability';
  var API_KEY = CFG.eddApiKey || '';
  var API_TIMEOUT = parseInt(CFG.eddApiTimeoutMs, 10) || 6000;
  // The API returns a single ETA date; we show a window of eddDate .. eddDate + buffer.
  var API_BUFFER_DAYS = (CFG.eddBufferDays === undefined || CFG.eddBufferDays === null)
    ? 1
    : (parseInt(CFG.eddBufferDays, 10) || 0);

  var NOT_SERVICEABLE_MSG = 'Sorry! We currently do not provide shipping services to this location.';

  var TRUCK_SVG = '<svg viewBox="0 0 24 22" role="presentation"><g transform="translate(1 1)" stroke-width="1.5" fill="none" fill-rule="evenodd"><path d="M5 10H2M5 15H4" stroke="#000" stroke-linecap="square"></path><path stroke="#000" d="M16.829 16H22v-6l-4-2-1-4H9v12h2.171"></path><path d="M0 5h5" stroke="#000" stroke-linecap="square"></path><path stroke="#000" stroke-linecap="square" d="M0 0h9v4"></path><circle stroke="#000" stroke-linecap="square" cx="14" cy="17" r="3"></circle><path stroke="#000" stroke-linecap="square" d="M13 7v2h2"></path></g></svg>';

  // ---------------------------------------------------------------------------
  // CSV parsing helpers (fallback path)
  // ---------------------------------------------------------------------------
  function parseCsv(text) {
    if (!text) return [];
    text = text.replace(/^﻿/, '').trim();
    if (!text) return [];
    var lines = text.split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean);
    if (lines.length === 0) return [];
    var headers = lines.shift().split(',').map(function (h) { return h.trim(); });
    var rows = [];
    lines.forEach(function (line) {
      var cols = line.split(',').map(function (c) {
        var t = c.trim();
        if (t.length >= 2 && t[0] === '"' && t[t.length - 1] === '"') t = t.substring(1, t.length - 1);
        return t;
      });
      var row = {};
      for (var i = 0; i < headers.length; i++) {
        row[headers[i]] = cols[i] !== undefined ? cols[i] : '';
      }
      rows.push(row);
    });
    return rows;
  }

  function buildMaps(rows) {
    var pre = {};
    var cod = {};
    rows.forEach(function (r) {
      var pin = (r['Pincode'] || r['pincode'] || '').trim();
      if (!pin) return;

      var hoursRaw = (r['Hours'] || r['hours'] || '').trim();
      var daysRaw = (r['Days'] || r['days'] || '').trim();
      var codRaw = (r['COD'] || r['cod'] || '').trim();

      // Prepaid mapping:
      if (hoursRaw === '#N/A' || daysRaw === '#N/A') {
        pre[pin] = '#N/A';
      } else if (hoursRaw !== '') {
        var h = parseInt(hoursRaw, 10);
        if (!isNaN(h) && h > 0) pre[pin] = String(h); // store hours as string (e.g. "24")
      } else if (daysRaw !== '') {
        var d = parseInt(daysRaw, 10);
        if (!isNaN(d) && d > 0) pre[pin] = String(d * 24); // convert days -> hours
      }

      // COD mapping (normalized)
      if (codRaw && codRaw.toLowerCase && codRaw.toLowerCase() === 'yes') cod[pin] = 'Yes';
      else cod[pin] = 'Not serviceable';
    });

    return { ziplistpredt: JSON.stringify(pre), ziplistcoddt: JSON.stringify(cod) };
  }

  // --- Fetch CSV (admin first, then fallback asset) ---
  async function fetchCsvPreferAdmin() {
    if (CSV_URL) {
      try {
        var r = await fetch(CSV_URL, { cache: 'no-store' });
        if (r.ok) {
          var t = await r.text();
          if (t && t.trim()) return t;
        } else {
          console.warn('CSV fetch failed (admin URL):', r.status);
        }
      } catch (e) {
        console.warn('CSV fetch error (admin URL):', e);
      }
    }
    // fallback to asset
    try {
      var r2 = await fetch(ASSETS_FALLBACK, { cache: 'no-store' });
      if (r2.ok) {
        var t2 = await r2.text();
        if (t2 && t2.trim()) return t2;
      } else {
        console.warn('CSV fetch failed (asset):', r2.status);
      }
    } catch (e2) {
      console.warn('CSV fetch error (asset):', e2);
    }
    return null;
  }

  // Loaded lazily: only when the API could not answer.
  var fallbackDataPromise = null;

  function ensureFallbackData() {
    if (!fallbackDataPromise) fallbackDataPromise = loadFallbackData();
    return fallbackDataPromise;
  }

  async function loadFallbackData() {
    try {
      var csvText = await fetchCsvPreferAdmin();
      if (csvText) {
        var maps = buildMaps(parseCsv(csvText));
        window.ziplistpredt = maps.ziplistpredt;
        window.ziplistcoddt = maps.ziplistcoddt;
        window._deliveryCsvRaw = csvText; // keep raw for debugging if needed
      }
      // No CSV -> keep whatever pincode-list.js already put on window (last resort).
    } catch (e) {
      console.warn('Unexpected error while loading delivery CSV:', e);
    }

    var pre = {};
    var cod = {};
    try { pre = JSON.parse(window.ziplistpredt || '{}'); } catch (e) { pre = {}; }
    try { cod = JSON.parse(window.ziplistcoddt || '{}'); } catch (e) { cod = {}; }
    return { pre: pre, cod: cod };
  }

  // ---------------------------------------------------------------------------
  // Date helpers
  // ---------------------------------------------------------------------------
  var DAY_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function ordinalSuffix(n) {
    if (n > 3 && n < 21) return 'th';
    switch (n % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }

  // Same shape date.js produced: "Mon, Aug 10th"
  function formatDate(d) {
    return DAY_NAMES[d.getDay()] + ', ' + MONTH_NAMES[d.getMonth()] + ' ' + d.getDate() + ordinalSuffix(d.getDate());
  }

  function addDays(d, n) {
    var copy = new Date(d.getTime());
    copy.setDate(copy.getDate() + n);
    return copy;
  }

  // API sends a human string like "Monday, Aug 10" (no year). ISO is tolerated too.
  function parseApiDate(value) {
    if (!value) return null;
    var s = String(value).trim();

    var iso = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (iso) return new Date(parseInt(iso[1], 10), parseInt(iso[2], 10) - 1, parseInt(iso[3], 10));

    var m = s.replace(/^[A-Za-z]+,\s*/, '').match(/([A-Za-z]{3,})\s+(\d{1,2})(?:\s*,?\s*(\d{4}))?/);
    if (!m) return null;

    var monthIdx = -1;
    var monthKey = m[1].slice(0, 3).toLowerCase();
    for (var i = 0; i < MONTH_NAMES.length; i++) {
      if (MONTH_NAMES[i].toLowerCase() === monthKey) { monthIdx = i; break; }
    }
    if (monthIdx < 0) return null;

    var day = parseInt(m[2], 10);
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var year = m[3] ? parseInt(m[3], 10) : today.getFullYear();
    var parsed = new Date(year, monthIdx, day);

    // No year in the payload: a date well in the past means the year rolled over (Dec -> Jan).
    if (!m[3] && parsed.getTime() < today.getTime() - 45 * 86400000) {
      parsed = new Date(year + 1, monthIdx, day);
    }
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  // eddDate -> "Mon, Aug 10th to Tue, Aug 11th"
  function apiDeliveryWindow(eddDate) {
    var start = parseApiDate(eddDate);
    if (!start) return null;
    if (start.getDay() === 0) start = addDays(start, 1); // same Sunday rule as the CSV path
    if (API_BUFFER_DAYS <= 0) return formatDate(start);
    var end = addDays(start, API_BUFFER_DAYS);
    return formatDate(start) + ' to ' + formatDate(end);
  }

  // --- caldays: accepts HOURS or DAYS (auto-detect) — used by the CSV fallback ---
  function caldays(toCurrentHourPlus, tatValue) {
    var tatDays = 0;

    if (tatValue === undefined || tatValue === null || tatValue === '') {
      tatDays = 0;
    } else {
      var tatNum = parseInt(tatValue, 10);
      if (!isNaN(tatNum)) {
        // If number >= 24 => it's hours; else treat as days
        if (tatNum >= 24) {
          tatDays = Math.ceil(tatNum / 24);
        } else {
          tatDays = tatNum;
        }
      } else {
        tatDays = 0;
      }
    }

    var toCurrentDate = new Date();
    var toCurrentHour = toCurrentDate.getHours();

    if (toCurrentHour >= 14) { toCurrentHourPlus = toCurrentHourPlus + 1; }
    if (tatDays > 0) {
      toCurrentHourPlus = toCurrentHourPlus + tatDays;
    }

    var fromDate = addDays(new Date(), toCurrentHourPlus);
    if (fromDate.getDay() === 0) fromDate = addDays(fromDate, 1);
    var toDate = addDays(fromDate, 1);

    return formatDate(fromDate) + ' to ' + formatDate(toDate);
  }

  // ---------------------------------------------------------------------------
  // Cobay EDD API (priority 1)
  // ---------------------------------------------------------------------------
  var apiCache = {};

  function fetchEdd(pincode) {
    if (!API_URL || !API_KEY) return Promise.resolve(null);
    if (apiCache[pincode]) return apiCache[pincode];

    var url = API_URL + (API_URL.indexOf('?') === -1 ? '?' : '&') +
      'apiKey=' + encodeURIComponent(API_KEY) +
      '&pincode=' + encodeURIComponent(pincode);

    var controller = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    var timer = setTimeout(function () { if (controller) controller.abort(); }, API_TIMEOUT);

    // The API answers with HTTP status, not a flag:
    //   200 {pincode, city, eddDate}                     -> serviceable
    //   400 {"message":"Pincode is not serviceable"}     -> definitively not serviceable
    //   anything else                                    -> unusable, caller falls back to CSV
    var request = fetch(url, controller ? { signal: controller.signal } : {})
      .then(function (r) {
        return r.json()
          .catch(function () { return null; })
          .then(function (data) { return { ok: r.ok, status: r.status, data: data || {} }; });
      })
      .then(function (res) {
        clearTimeout(timer);
        var data = res.data;

        // Serviceable. (`serviceable: true` is the older payload shape — still accepted.)
        if (res.ok && (data.eddDate || data.serviceable === true)) {
          return { serviceable: true, eddDate: data.eddDate, city: data.city };
        }

        // Not serviceable — an authoritative answer, so don't fall through to the CSV.
        var message = String(data.message || '').toLowerCase();
        if (data.serviceable === false || (res.status === 400 && message.indexOf('not serviceable') !== -1)) {
          return { serviceable: false };
        }

        // Auth failure, bad pincode format, 5xx, unknown payload -> let the CSV answer.
        throw new Error('EDD API ' + res.status + (data.message ? ': ' + data.message : ''));
      })
      .catch(function (e) {
        clearTimeout(timer);
        console.warn('EDD API unavailable, falling back to CSV:', (e && e.message) ? e.message : e);
        delete apiCache[pincode]; // let a later attempt retry
        return null;
      });

    apiCache[pincode] = request;
    return request;
  }

  // ---------------------------------------------------------------------------
  // Rendering
  // ---------------------------------------------------------------------------
  function showResult(html) {
    $('.pincodersltpre').html(html);
    $('#pinresult').show();
  }

  function deliveryLine(intro, dateWindow) {
    return '<p class="text-with-icons__icon-wrapper">' + TRUCK_SVG +
      '<span>' + intro + ' <span id="fromDate" style="font-weight:600;">' + dateWindow + '</span></span></p>';
  }

  function errorLine(message) {
    return '<span style="color:red; display: block; margin-block-start: 10px; font-weight:600;">' + message + '</span>';
  }

  function setBusy(isBusy) {
    var $btn = $('#pinSubmit');
    if (isBusy) {
      $btn.prop('disabled', true).text('Checking…');
    } else {
      $btn.prop('disabled', false).text('Check');
    }
  }

  // --- CSV/asset fallback rendering (original behaviour, unchanged) ---
  function renderFromFallback(pincodeValue, data, intro) {
    var selzip = data.pre[pincodeValue];
    var selzipcod = data.cod[pincodeValue];

    if (selzip !== undefined) {
      if (selzip == '#N/A') {
        showResult('<span style="color:red;"><span style="font-weight:600;">Sorry...!</span> Prepaid Service Not available for this pincode.</span>');
        return;
      }

      var pincode = parseInt(pincodeValue, 10);
      var deliveryDays = 5; // Default 5 days
      // 3 days delivery for pincodes between 600001 and 600120
      if (pincode >= 600001 && pincode <= 600120) {
        deliveryDays = 3;
      }

      showResult(deliveryLine(intro, caldays(0, deliveryDays)));
      return;
    }

    if (selzipcod !== undefined) {
      if (selzip == selzipcod) {
        showResult('');
        return;
      }
      var codBlocked = COD_ENABLED &&
        (selzipcod == 'Not serviceable' || String(selzipcod).toLowerCase() === 'no');
      if (codBlocked) {
        showResult('<p class="text-with-icons__icon-wrapper">' + TRUCK_SVG +
          '<span>Expected Delivery Time: 3-6 Working Days.</span></p>' +
          '<span style="color:red;"> Sorry! Cash on Delivery is not available for this pincode!</span>');
      } else {
        showResult('<p class="text-with-icons__icon-wrapper">' + TRUCK_SVG +
          '<span>Expected Delivery Time: 3-6 Working Days</span></p>');
      }
      return;
    }

    showResult(errorLine(NOT_SERVICEABLE_MSG));
  }

  // ---------------------------------------------------------------------------
  // Main check — API first, CSV/asset second
  // ---------------------------------------------------------------------------
  async function checkPincode(rawValue, intro) {
    var value = String(rawValue === null || rawValue === undefined ? '' : rawValue).trim();

    $('.checkpinerr').html('');

    if (value === '') {
      showResult('<span style="color:red;">Please enter a pincode!</span>');
      return;
    }
    if (!/^\d+$/.test(value)) {
      showResult('<span style="color:red;">Please enter a valid numeric pincode!</span>');
      return;
    }
    if (!/^[1-9]\d{5}$/.test(value)) {
      showResult('<span style="color:red;">Please enter a valid 6-digit pincode!</span>');
      return;
    }

    if (typeof (Storage) !== 'undefined') {
      try { sessionStorage.setItem('pincode', value); } catch (e) { /* private mode */ }
    }

    setBusy(true);
    showResult('<span style="color:#696e79;">Checking delivery date…</span>');

    try {
      // 1) Cobay EDD API
      var api = await fetchEdd(value);
      if (api) {
        if (api.serviceable === false) {
          showResult(errorLine(NOT_SERVICEABLE_MSG));
          return;
        }
        var dateWindow = apiDeliveryWindow(api.eddDate);
        if (dateWindow) {
          showResult(deliveryLine(intro, dateWindow));
          return;
        }
        console.warn('EDD API returned no usable eddDate, falling back to CSV');
      }

      // 2/3/4) CSV -> asset CSV -> pincode-list.js globals
      var data = await ensureFallbackData();
      renderFromFallback(value, data, intro);
    } finally {
      setBusy(false);
    }
  }

  // ---------------------------------------------------------------------------
  // Wire up UI
  // ---------------------------------------------------------------------------
  var exispincode = '';
  if (typeof (Storage) !== 'undefined') {
    exispincode = sessionStorage.getItem('pincode');
  }
  $('#chkpin').val(exispincode || '');
  $('#pinresult').hide();

  $('.tickbtn').on('click', function () {
    checkPincode($('#chkpin').val(), 'You can expect delivery between');
  });

  // --- Trigger pincode check on Enter key ---
  $('#chkpin').on('keydown', function (e) {
    if (e.key === 'Enter' || e.keyCode === 13) {
      e.preventDefault();
      $('.tickbtn').trigger('click');
    }
  });

  // Restore the result for a pincode checked earlier in this session.
  $(window).on('load', function () {
    var saved = String(exispincode || '').trim();
    if (saved === '' || saved === 'null' || saved === 'undefined') return;
    checkPincode(saved, 'Your delivery will be received between');
  });
})(); // end IIFE
